<template>
    <h2 class="my-text-black" style="text-align: center;">Perfil administrador</h2>
    <h3 class="my-text-black">Información</h3>
    <div class="mb-2"><v-divider id="divider"></v-divider></div>
    <v-expansion-panels>
        <v-expansion-panel style="z-index: 0;">
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-account-search">
            Buscar usuario
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <BuscarUsuario></BuscarUsuario>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel style="z-index: 0;">
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-briefcase-search">
            Buscar profesional
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <BuscarProfesional></BuscarProfesional>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
    <h3 class="my-text-black">Creación usuarios</h3>

    <v-divider class="mb-2" id="divider"></v-divider>
    <v-expansion-panels>
         <v-expansion-panel style="z-index: 0;">
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-account-plus ml-4">
            Agregar Usuario
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <CrearUsuarioForm></CrearUsuarioForm>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-account-convert">
            Resetear Contraseña
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <PasswordResetForm></PasswordResetForm>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-home-plus-outline">
            Asociar Usuario a Facturador
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarUsuNivFact></AsociarUsuNivFact>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-home-minus-outline">
            Desasociar Usuario a Facturador
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarUsuNivFact :desasociar="true"></AsociarUsuNivFact>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-hospital-marker">
            Asociar Auditor a Obra Social
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarAuditorOS></AsociarAuditorOS>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-inbox">
            Asociar Autorizador a Bandeja
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarAutBandeja></AsociarAutBandeja>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
    <h3 class="my-text-black">Creación profesionales</h3>

    <v-divider class="mb-2" id="divider"></v-divider>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-doctor">
            Agregar profesional
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <CrearProfesionalForm></CrearProfesionalForm>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-doctor">
            Editar profesional
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <EditarProfesional></EditarProfesional>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-hospital-building">
            Asociar profesional a facturador
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarProfFact></AsociarProfFact>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-hospital-building">
            Desasociar profesional a facturador
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarProfFact :desasociar="true"></AsociarProfFact>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-medical-bag">
            Asociar profesional a especialidad/es
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarProfEsp></AsociarProfEsp>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-medical-bag">
            Desasociar profesional especialidad
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <AsociarProfEsp :desasociar="true"></AsociarProfEsp>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
    <!-- <h3 class="my-text-black">Creación obras sociales</h3>

    <v-divider class="mb-2" id="divider"></v-divider>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-hospital-marker">
            Agregar obra social
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <CrearObraSocial></CrearObraSocial>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-title collapse-icon="mdi-minus" expand-icon="mdi mdi-hospital-marker">
            Agregar plan a obra social
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <CargarPlanOS></CargarPlanOS>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels> -->
</template>
<style src="../assets/general.css"></style>
<script>
    import CrearUsuarioForm from './CrearUsuarioForm.vue';
    import PasswordResetForm from './PasswordResetForm.vue';
    import CrearProfesionalForm from './CrearProfesionalForm.vue';
    import AsociarProfFact from './AsociarProfFact.vue';
    import AsociarProfEsp from './AsociarProfEsp.vue';
    import BuscarUsuario from './BuscarUsuario.vue';
    import BuscarProfesional from './BuscarProfesional.vue';
    import CrearObraSocial from './CrearObraSocial.vue';
    import CargarPlanOS from './CargarPlanOS.vue';
    import AsociarUsuNivFact from './AsociarUsuNivFact.vue';
    import EditarProfesional from './EditarProfesional.vue';
    import AsociarAuditorOS from './AsociarAuditorOS.vue';
    import AsociarAutBandeja from './AsociarAutBandeja.vue';

    export default {
        components: {
            CrearUsuarioForm,
            PasswordResetForm,
            CrearProfesionalForm,
            AsociarProfFact,
            AsociarProfEsp,
            BuscarUsuario,
            BuscarProfesional,
            // CrearObraSocial,
            // CargarPlanOS,
            AsociarUsuNivFact,
            EditarProfesional,
            AsociarAuditorOS,
            AsociarAutBandeja
        }
    }
</script>